import React from 'react';
import { Button } from 'reactstrap';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';

const EditPractitionerButton = (
  props: RouteComponentProps<{
    organizationId: string;
    practitionerId: string;
  }> & {
    loading?: boolean;
    className?: string;
  },
) => {
  return (
    <Button
      tag={Link}
      color="success"
      className={
        props.className ? `${props.className} text-center` : 'text-center'
      }
      to="/profile/edit"
      disabled={props.loading}>
      Edit
    </Button>
  );
};

export default withRouter(EditPractitionerButton);
